export const primaryMain = '#3f51b5';
export const primaryLight = 'rgb(101, 115, 195)';
export const primaryDark = 'rgb(44, 56, 126)';
export const primaryContrast = '#fff';

export const secondaryMain = '#f50057';
export const secondaryLight = 'rgb(247, 51, 120)';
export const secondaryDark = 'rgb(171, 0, 60)';
export const secondaryContrast = '#fff';

export const errorMain = '#f44336';
export const errorLight = '#e57373';
export const errorDark = '#d32f2f';
export const errorContrast = '#fff';

export const warningMain = '#ff9800';
export const warningLight = '#ffb74d';
export const warningDark = '#f57c00';
export const warningContrast = 'rgba(0, 0, 0, 0.87)';

export const infoMain = '#2196f3';
export const infoLight = '#64b5f6';
export const infoDark = '#1976d2';
export const infoContrast = '#fff';

export const successMain = '#4caf50';
export const successLight = '#81c784';
export const successDark = '#388e3c';
export const successContrast = 'rgba(0, 0, 0, 0.87)';

export const dividerMain = 'rgba(0, 0, 0, 0.12)';

const palette = {
  primary: {
    main: primaryMain,
    light: primaryLight,
    dark: primaryDark,
    contrast: primaryContrast
  },
  secondary: {
    main: secondaryMain,
    light: secondaryLight,
    dark: secondaryDark,
    contrast: secondaryContrast
  },
  error: {
    main: errorMain,
    light: errorLight,
    dark: errorDark,
    contrast: errorContrast
  },
  warning: {
    main: warningMain,
    light: warningLight,
    dark: warningDark,
    contrast: warningContrast
  },
  info: {
    main: infoMain,
    light: infoLight,
    dark: infoDark,
    contrast: infoContrast
  },
  success: {
    main: successMain,
    light: successLight,
    dark: successDark,
    contrast: successContrast
  }
};

export default palette;
